import React from "react";
import Header from "../../common/Header";
import { Button, Typography } from "@mui/material";
import { Flex } from "../../styled";
import { useNavigate } from "react-router-dom";

import { StyledMainContainer } from "../../../pages/Colaborator/styled";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <>
      <StyledMainContainer style={{ justifyContent: "center" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "50vh",
            width: "100%",
            flexDirection: "column",
            gap: "1rem",
          }}
        >
          <Typography sx={{ color: "white", textAlign: "center" }}>
            Oops 404, ruta no encontrada!{" "}
          </Typography>
          <button
            onClick={() => {
              window.location.href = window.location.origin + "/";
            }}
            style={{
              padding: "0.5rem 1rem",
              backgroundColor: "#4fc3d7",
              color: "white",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            Reintentar
          </button>
        </div>
      </StyledMainContainer>
    </>
  );
}
